const environment = {
  SHOULD_RENDER_PROJECT_UNAUTHORIZED:
    import.meta.env.VITE_HIDE_NO_ACCESS_PAGE !== 'true',
  SHOULD_RENDER_NUM_REQUESTS: import.meta.env.VITE_SHOW_NUM_REQUESTS === 'true',
  CYPRESS: import.meta.env.BASE_URL.startsWith('/__cypress/src/'),
  DISABLE_VORTEX: import.meta.env.VITE_DISABLE_VORTEX === 'true',
};

export default environment;
